// extracted by mini-css-extract-plugin
module.exports = {"headerToggler":"TableItemToggler_headerToggler__20bDZ","isBodyCollapsed":"TableItemToggler_isBodyCollapsed__3JyKc"};